const ModuleEnum = Object.freeze({
    ResultSheet: { id: "ResultSheet", name: 'Result Sheet' },
    Fortnox: { id: 'Fortnox', name: 'Fortnox' },
    PageBuilder: { id: 'PageBuilder', name: 'Page Builder' },
    BusinessCentral: { id: 'BusinessCentral', name: 'Business Central' },
    PowerOffice: { id: 'PowerOffice', name: 'Power Office' },
    NetVisor: { id: 'NetVisor', name: 'Netvisor' },
    Finance: { id: 'Finance', name: 'Finance' },

});

export default ModuleEnum;